<template>
    <div class="full-height">
        <router-view/>

        <Modal ref="modal"/>

        <v-snackbar class="general-snackbar" v-model="snackbar" :color="color" :timeout="timeout" :vertical="false" >
            {{ text }}
            <v-btn dark flat @click="snackbar = false" >
                Close
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>

    import Modal from "@/components/Modal.vue";
    import { VSnackbar, VBtn } from 'vuetify/lib'

    export default {
        name: 'MainLayout',
        components: {
            Modal,
            VSnackbar,
            VBtn
        },
        data () {
            return {
                isModalVisible: false,
                snackbar: false,
                color: '',
                timeout: 6000,
                text: 'Hello, I\'m a snackbar'
            }
        },
        created() {
            if (this.$user) {
                this.$socket.emit('LOGIN', {id: this.$user._id});
            }

            this.$root.$on('show-modal', (event) => {
                this.showModal(event)
            });
            this.$root.$on('close-modal', (event) => {
                this.closeModal(event)
            });

            this.$root.$on('show-snackbar', (event) => {
                this.showSnackbar(event)
            });
            this.$root.$on('close-snackbar', (event) => {
                this.closeSnackbar(event)
            });
        },
        methods: {
            showModal(event) {
                this.$refs.modal.setInformation(event);
                this.$refs.modal.show();
            },
            closeModal() {
                this.$refs.modal.hide();
            },
            showSnackbar(event){
                this.snackbar = true;
                this.color= event.color;
                this.timeout= event.timeout;
                this.text= event.message;
            },
            closeSnackbar(){
                this.snackbar = false;
            },
        },

        sockets: {

            STAMINA(data) {
                this.$root.$emit('update-stamina', {value: data*1});
            }


        },
    };
</script>
